import axiosInstance from './axios-instance';

export const api = axiosInstance;
export default api;
